import React, { useState } from 'react';
import { Search } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

interface HeroProps {
  title?: string;
  subtitle?: string;
  showSearch?: boolean;
}

export default function Hero({ title, subtitle, showSearch = true }: HeroProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  const currentLocation = useLocation();

  const isOnCrafties = currentLocation.pathname === '/crafties';

  // Always navigate to the unified /search route for consistent search behavior
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (!searchTerm.trim()) return;
    
    // Use 'q' param to match the main search page expectations
    const params = new URLSearchParams();
    params.set('q', searchTerm.trim());
    // Optionally filter by type based on current page
    if (isOnCrafties) {
      params.set('type', 'craftie');
    }
    navigate(`/search?${params.toString()}`);
  };

  return (
    <div className="relative py-16 sm:py-24">
      {/* Overlay Image */}
      <div 
        className="absolute inset-0 bg-center bg-no-repeat opacity-10"
        style={{
          backgroundImage: 'url(/hero-overlay-mainstreet-market.png)',
          backgroundSize: 'cover'
        }}
      />
      
      {/* Content Container */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl md:text-6xl">
            {title || 'Local Business Directory'}
          </h1>
          <p className="mt-3 max-w-md mx-auto text-base text-gray-500 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
            {subtitle || 'Discover skilled professionals and local artisans.'}
          </p>

          {/* Navigation Links */}
          {/* <div className="mt-8 flex justify-center space-x-6">
            <a
              href="/trades"
              className={`flex items-center px-6 py-3 rounded-lg text-base font-medium transition-colors ${
                !isOnCrafties
                  ? 'bg-blue-600 text-white hover:bg-blue-700'
                  : 'bg-white/10 text-white hover:bg-white/20'
              }`}
            >
              <Briefcase className="w-5 h-5 mr-2" />
              Find Traders
            </a>
            <a
              href="/crafties"
              className={`flex items-center px-6 py-3 rounded-lg text-base font-medium transition-colors ${
                isOnCrafties
                  ? 'bg-blue-600 text-white hover:bg-blue-700'
                  : 'bg-white/10 text-white hover:bg-white/20'
              }`}
            >
              <Palette className="w-5 h-5 mr-2" />
              Browse Crafties
            </a>
          </div> */}
        </div>

        {showSearch && (
        <form onSubmit={handleSearch} className="mt-8 sm:mt-12">
          <div className="flex flex-col sm:flex-row gap-4 max-w-3xl mx-auto">
            <div className="flex-1 relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Search className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="text"
                placeholder={isOnCrafties ? "Search for artisans and crafts..." : "What service are you looking for?"}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="block w-full pl-10 pr-3 py-3 text-base border border-blue-400 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <button
              type="submit"
              className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-lg shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Search
            </button>
          </div>
        </form>
        )}
      </div>
    </div>
  );
}